export const SET_ACTIVE_WALLET_TAB = "SET_ACTIVE_WALLET_TAB";
export const SHOW_SIDE_MENU = "SHOW_SIDE_MENU";
export const HIDE_SIDE_MENU = "HIDE_SIDE_MENU";
export const SET_WALLET_DETAILS = "SET_WALLET_DETAILS";
export const SET_PROGRESS_DETAILS = "SET_PROGRESS_DETAILS";
export const BUTTON_DISABLE = "BUTTON_DISABLE";
export const BUTTON_ENABLE = "BUTTON_ENABLE";
